import { render, staticRenderFns } from "./pimproBoard.vue?vue&type=template&id=1a58362c&"
import script from "./pimproBoard.vue?vue&type=script&lang=js&"
export * from "./pimproBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports